document.addEventListener("DOMContentLoaded", () => {

    const subscriptionSelect = document.querySelector(".product-subscription select");
    const subscriptionSwitch = document.querySelector(".subscription-toggle__switch.toggle-switch input");
    const currentVariantInput = document.querySelector(".product-info__buy-buttons form input[name='id']");
    const subscriptionVariants = JSON.parse(document.querySelector(".product-subscription [subscription-variants]").textContent);

    if (!subscriptionSelect || !subscriptionSwitch || !currentVariantInput) return;

    if (!isPlanAvailableForVariant(currentVariantInput.value, subscriptionVariants)) {
        handleVariantInputChange();
        handleSubscriptionSelectChange();
    }

    subscriptionSelect.addEventListener("change", handleSubscriptionSelectChange);
    currentVariantInput.addEventListener("change", handleVariantInputChange);
    subscriptionSwitch.addEventListener("change", handleSubscriptionSwitchChange);

    callDispatchEvent();

    function getCurrentVariant(id,variants) {        
        return [...variants].find( variant => variant.id == id);
    }

    function handleVariantInputChange() {
        const variantId = currentVariantInput.value;
        const isPlanAvailable = isPlanAvailableForVariant(variantId, subscriptionVariants);

        if (!isPlanAvailable) {
            if (subscriptionSwitch.checked) {
                handleAttributeChange("false")
                triggerSubscriptionChange();
            }
            disableSubscriptionSwitch();
        } else {
            enableSubscriptionSwitch();
        }
    }

    function callDispatchEvent() {
        const variantId = document.querySelector(".product-info__buy-buttons form input[name='id']").value;        
        document.dispatchEvent(new CustomEvent('variant:subscription', { 
            bubbles: true, 
            detail: {
                    variant: getCurrentVariant(variantId, subscriptionVariants)
                }
            })
        );
    }

    function handleSubscriptionSwitchChange() {
        triggerSubscriptionChange();
        handleAttributeChange("true")
    }

    function handleAttributeChange(isManual) {
        subscriptionSwitch.setAttribute("data-manual", isManual)
    }

    function handleSubscriptionSelectChange() {
        const unselectedOption = [...subscriptionSelect.options].find(option => !option.selected);
        subscriptionSelect.value = unselectedOption?.value || subscriptionSelect.options[0].value;
    }

    function isPlanAvailableForVariant(variantId, variants) {
        if (!variantId || variantId === "undefined") return false;
        const variant = variants.find(variant => variant.id == variantId);
        return variant?.selling_plan_allocations?.length > 0 || false;
    }

    function triggerSubscriptionChange() {
        subscriptionSelect.dispatchEvent(new Event('change', { bubbles: true }));
        callDispatchEvent();
    }

    function disableSubscriptionSwitch() {
        subscriptionSwitch.checked = false;
        subscriptionSwitch.setAttribute("disabled", "disabled");
    }

    function enableSubscriptionSwitch() {
        subscriptionSwitch.removeAttribute("disabled");
    }
});
